module.exports = __webpack_public_path__ + "img/ico_add_client_white.65b6fae2.svg";